import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export default function TakeawayCancel() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-background border-2 border-foreground rounded-3xl shadow-brutal-lg p-8 text-center" data-testid="takeaway-cancel">
        <ShoppingBag size={44} className="mx-auto text-foreground/50" />
        <h1 className="font-head font-extrabold text-2xl mt-4">Order cancelled</h1>
        <p className="text-foreground/60 mt-2">No payment was taken. Your cart is safe — pop back any time.</p>
        <Link to="/" data-testid="cancel-home" className="inline-block mt-6 font-head font-bold border-2 border-foreground rounded-full px-6 py-2.5 hover:bg-muted">Back to Harbour Haze</Link>
      </div>
    </div>
  );
}
